import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponseAuthToken } from 'entities/Auth'

export class AuthorizedAppRow extends RowBase<IResponseAuthToken> {
  constructor(origin: IResponseAuthToken) {
    super(origin)
    makeObservableRowBase(this)
  }

  get name() {
    return this.origin.name ?? this.origin.client?.name ?? null
  }

  get created_at() {
    return this.origin.created_at
  }
}
